import { createContext, useContext, useState } from 'react';
import type { ReactNode } from 'react';

interface HelpDrawerContextValue {
  isOpen: boolean;
  pageKey: string;
  openHelp: (key: string) => void;
  closeHelp: () => void;
}

const HelpDrawerContext = createContext<HelpDrawerContextValue | undefined>(undefined);

export function HelpDrawerProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [pageKey, setPageKey] = useState('');

  const openHelp = (key: string) => {
    setPageKey(key);
    setIsOpen(true);
  };

  const closeHelp = () => {
    setIsOpen(false);
  };

  return (
    <HelpDrawerContext.Provider value={{ isOpen, pageKey, openHelp, closeHelp }}>
      {children}
    </HelpDrawerContext.Provider>
  );
}

export function useHelpDrawer() {
  const ctx = useContext(HelpDrawerContext);
  if (!ctx) throw new Error('useHelpDrawer must be used inside HelpDrawerProvider');
  return ctx;
}
